/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICommerceApiSettings } from '@msdyn365-commerce/core-internal';

/**
 * Generates a cache key from the given ApiSettings object
 */
export const getCacheKey = (apiSettings: ICommerceApiSettings, catalogId?: number) => {
    if (!apiSettings) {
        return '';
    }

    return `${apiSettings.channelId}-${apiSettings.oun}-${catalogId || 0} `;
};
